<form [formGroup]="form" class="grid grid-cols-12 flex-col gap-7">
    <section class="col-span-12">
        <span class="text-primary-800 text-3xl"
            >Designate a frequency selection method below.</span
        >
    </section>
    @for (
        formServiceSelectionOption of formServiceSelectionOptions;
        track formServiceSelectionOption.service
    ) {
        <section class="form-card-container">
            <app-submit-to-ewa-form-option
                [formOption]="formServiceSelectionOption"
                [disabled]="isReadOnly()"
                [selected]="
                    formServiceSelectionOption === this.selectedFormOption
                "
                [hasErrorHighlight]="!selectedFormOption && form.touched"
                (serviceSelected)="handleServiceSelection($event)"
            ></app-submit-to-ewa-form-option>
        </section>
    }
    <section class="form-card-container">
        <app-submit-to-ewa-form-submission
            (submitForm)="handoverToEwaSubmission()"
            [disableSubmission]="!enableSubmission()"
        >
        </app-submit-to-ewa-form-submission>
    </section>
</form>
